<template>
  <div>
    <div
      class="notifications__head d-flex justify-content-between align-items-center p-2">
      <div class="d-flex align-items-center">
        <div>
          <img
            v-if="notification.activityResult.createdBy.avatar"
            class="img-fluid rounded-circle member__img--notification mr-2"
            :src="notification.activityResult.createdBy.avatar">
          <b-avatar
            v-else
            :text="notification.activityResult.createdBy.name | initial"
            class="mr-2" />
        </div>
        <div>
          <div class="member__content d-flex align-items-center">
            <p class="member__name mr-2">
              {{ notification.activityResult.createdBy.name }}
            </p>
            <p
              class="member__title">
              {{ notification.activityResult.createdBy.position }}
            </p>
          </div>
          <div class="member__group">
            {{ notification.createdByGroup }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="p-2">
      <div class="d-flex align-items-center py-1">
        <img
          src="@/assets/images/icon_flag-b.svg"
          class="flag-icon ml-1 mr-1">
        <span
          v-if="notification.activityResult.goal.isLocked"
          class="material-icons goal-lock-icon">
          lock
        </span>

        <p class="font-weight-bold">
          {{ notification.activityResult.goal.name }}
        </p>
      </div>
      <notification-card-activity-panel
        :activity="notification.activityResult"
        @click-active="onClickActivePart" />
    </div>
  </div>
</template>

<script>
import NotificationCardActivityPanel from '@/components/view/NotificationCardActivityPanel.vue'

export default {
  components: {
    NotificationCardActivityPanel,
  },
  props: {
    notification: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      checked: false,
      isProtecting: false
    }
  },
  methods: {
    async onClickActivePart() {
      this.$emit('click-notification', this.notification.id)
    },
    onCheckRead() {
      this.checked = !this.checked
      this.$emit('check-read', this.notification.id)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/member';

.member__img--notification {
  width: 30px;
  height: 30px;
  object-fit: cover;
}

.member__group {
  font-size: $fs-s;
  color: $l-blue;
}

.flag-icon {
  height: 18px;
  width: auto;
}

.notifications-heading-mark {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background: $grey16;
  &--marked {
    background: $pink;
  }
}

.notifications{
  &__icon{
    display: inline-block;
    vertical-align: middle;
  }
  &__item{
    border: solid 1px $grey10;
    border-radius: 8px;
    background-color: $white;
  }
  &__heading{
    font-size: $fs-nm;
    font-weight: bold;
    position: relative;
  }
  &__box{
    text-align: right;
  }
  &__count{
    font-size: $fs-m;
    color: $l-blue;
    font-weight: bold;
  }
  &__date{
    font-size: $fs-s;
  }
  &__check {
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    position: relative;
    width: auto;
    &:before {
      background: #fff;
      border: 1px solid $grey05;
      content: '';
      display: block;
      height: 26px;
      margin-top: -10px;
      position: absolute;
      top: 50%;
      width: 26px;
      border-radius: 4px;
      right: 0;
    }
    &:after {
      border-right: 4px solid $l-blue;
      border-bottom: 4px solid $l-blue;
      content: '';
      display: block;
      height: 16px;
      margin-top: -7px;
      opacity: 0;
      position: absolute;
      top: 50%;
      transform: rotate(45deg);
      width: 10px;
      border-radius: 2px;
      right: 7px;
    }
  }
}

.notifications-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  &__btn {
    padding: 16px 8px;
  }
}

.comment{
  &__img{
    width: 30px;
    height: 30px;
    object-fit: cover;
  }
  &__name{
    font-weight: bold;
    font-size: $fs-m;
  }
  &__date{
    font-size: $fs-m;
  }
  &__body{
    white-space:pre-wrap;
    word-wrap:break-word;
    color: $grey04;
  }
}

</style>